import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import addAppCustom from "./components/addAppCustom";
import customDetails from "./components/customDetails.vue";
import config from "@/config/index";
import { project_add, project_list, project_del, project_update, company_list } from "@/api/pests";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      tableHeight: 400,
      tableDataList1: [],
      spinShow: false,
      spinShow1: false,
      companyList: [],
      reduceheight: 55,
      showTable: 0,
      setData: null,
      currClientId: null,
      //当前选择的应用id
      form_filter: {
        project_name: null,
        company_code: null
      },
      //共用的查询与重置
      topButtonList: [{
        name: "查询",
        type: "primary",
        method: this.search
      }, {
        name: "重置",
        type: "error",
        method: this.reset
      }],
      //共用的右侧添加按钮
      topButtonList1: [{
        name: "添加",
        icon: "ios-add",
        type: "primary",
        method: this.add
      }, {
        name: "刷新",
        icon: "ios-refresh",
        type: "primary",
        method: this.refresh
      }],
      reqBase: {
        page: 1,
        page_size: 10
      },
      reqBase1: {
        page: 1,
        page_size: 10
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      getPageTotal1: 0,
      operationButtonList: [// {
      //   name:'进入项目',
      //   type:'primary',
      //   icon:'',
      //   method:this.mechanHome
      // },
      {
        name: "详情",
        type: "text",
        icon: "ios-paper-outline",
        method: this.details
      }, {
        name: "编辑",
        type: "text",
        icon: "ios-create-outline",
        method: this.edit
      }, {
        name: "删除",
        type: "text",
        icon: "ios-trash-outline",
        method: this.del
      }],
      operationButtonList1: [{
        name: this.$t("operationModule.submitReview"),
        type: "primary",
        icon: "",
        method: this.submitReview
      }],
      columnsheader: [// {
      //   align: "center",
      //   title: "序号",
      //   minWidth: 120,
      //   key: "xuhao"
      // },
      {
        align: "center",
        title: "项目",
        minWidth: 120,
        key: "project_name",
        render: function render(h, _ref) {
          var row = _ref.row;
          var vm = _this2;
          return h("div", {
            style: {
              cursor: "pointer",
              color: "#2d8cf0"
            },
            on: {
              click: function click() {
                vm.mechanHome(row);
              }
            }
          }, row.project_name);
        }
      }, {
        align: "center",
        title: "客户负责人",
        minWidth: 120,
        key: "customer_user"
      }, {
        align: "center",
        title: "联系方式",
        minWidth: 120,
        key: "tel"
      }, {
        align: "center",
        title: "地址",
        minWidth: 100,
        key: "address"
      }, {
        align: "center",
        title: "创建日期",
        minWidth: 100,
        key: "addtime"
      }, {
        align: "center",
        title: "操作",
        width: 200,
        key: "Operating",
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var arr = [];

          var _loop = function _loop(i) {
            var list = _this2.operationButtonList[i];
            arr.push(h("Button", {
              style: {
                marginLeft: "5px",
                marginBottom: "3px",
                color: "#2d8cf0"
              },
              props: {
                type: list.type,
                size: list.size ? list.size : "small"
              },
              on: {
                click: function click() {
                  list.method(row);
                }
              }
            }, list.name));
          };

          for (var i in _this2.operationButtonList) {
            _loop(i);
          }

          return h("div", arr);
        }
      }]
    };
  },
  components: {
    customDetails: customDetails
  },
  computed: {
    userInfo: function userInfo() {
      var state = this.$store.state.user.userInfo.project_list_teshu;
      return state;
    }
  },
  methods: {
    onSearchCompany: function onSearchCompany(value) {
      this.getcompany(value);
    },
    getcompany: function getcompany(company_name) {
      var _this3 = this;

      this.spinShow = true;
      this.companyList.splice(0);
      var params = {};

      if (company_name) {
        params["company_name"] = company_name;
      }

      company_list(params).then(function (res) {
        _this3.spinShow = false;

        if (res.result === 0) {
          var list = res.body || [];

          if (company_name === undefined || company_name === "") {
            _this3.companyList.push({
              company_code: -1,
              company_name: "全部"
            });
          }

          for (var i in list) {
            var item = list[i];
            item.selected = false;

            _this3.companyList.push(item);
          }

          if (_this3.companyList && _this3.companyList.length > 0) {
            _this3.$set(_this3.companyList[0], "selected", true);

            _this3.cellGroupClick(_this3.companyList[0].company_code);
          }
        } else {
          _this3.companyList = [];

          _this3.$Message.error(res.errorMsg);
        }
      });
    },
    cellGroupClick: function cellGroupClick(code) {
      for (var i in this.companyList) {
        var item = this.companyList[i];

        if (item.company_code === code) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      }

      this.$set(this.reqBase1, "company_code", code);
      this.reqBase1.page = 1; //重置当前的page
      // this.$refs.pageRef.current=1;

      this.init1();
    },
    gotoProject: function gotoProject(item) {},
    init1: function init1() {
      var _this4 = this;

      this.spinShow1 = true;
      this.tableDataList1.splice(0);
      var company_code = this.reqBase1.company_code;

      if (company_code === -1) {
        company_code = null;
      }

      project_list(_objectSpread({}, this.reqBase1, {
        company_code: company_code
      })).then(function (res) {
        _this4.spinShow1 = false;

        if (res.result === 0) {
          _this4.tableDataList1 = res.body.list || [];
          _this4.getPageTotal1 = res.body.total;
        } else {
          _this4.tableDataList1 = [];
          _this4.getPageTotal1 = 0;

          _this4.$Message.error(res.errorMsg);
        }
      });
    },
    pageOnchange1: function pageOnchange1(index) {
      this.reqBase1.page = index;
      this.init1();
    },
    changeList: function changeList() {
      if (this.showTable === 0) {
        if (this.tableDataList.length === 0) {
          this.init();
        }

        this.showTable = 1;
      } else if (this.showTable === 1) {
        this.showTable = 0;
      }
    },
    mechanHome: function mechanHome(row) {
      this.$router.push({
        name: "projectManage",
        title: row.project_name,
        params: {
          code: row.project_code,
          name: row.project_name,
          id: row.id
        }
      });
    },
    pageSizeChange: function pageSizeChange() {},
    init: function init() {
      var _this5 = this;

      this.tableLoading = true;
      project_list(_objectSpread({}, this.reqBase)).then(function (res) {
        _this5.tableLoading = false;
        _this5.tableDataList = [];

        if (res.result === 0) {
          _this5.tableDataList = res.body.list || [];
          _this5.getPageTotal = res.body.total;
        } else {
          _this5.tableDataList = [];
          _this5.getPageTotal = 0;

          _this5.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    add: function add() {
      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, "添加"), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(addAppCustom, {
            ref: "addAppCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              project_add(formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();

                  if (vm.showTable === 0) {
                    vm.init1();
                  } else {
                    vm.init();
                  }
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        project_name: null,
        company_code: null,
        status: -1
      };
      this.search();
    },
    details: function details(row) {
      var vm = this;
      var config = {
        loading: true,
        width: 800,
        okText: "关闭",
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, "详情"), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(customDetails, {
            ref: "customDetails",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          vm.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },
    edit: function edit(row) {
      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, "编辑"), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(addAppCustom, {
            ref: "addAppCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (req) {
            if (req) {
              //提交请求
              var formModel = obj.formModel;
              project_update(_objectSpread({}, formModel, {
                company_code: row.company_code
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  debugger;

                  if (vm.showTable === 0) {
                    vm.init1();
                  } else {
                    vm.init();
                  }
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del: function del(row) {
      var vm = this;
      var config = {
        loading: true,
        title: this.$t('删除'),
        content: this.$t('您确定要删除') + row.project_name + '?',
        onOk: function onOk() {
          var _this = this;

          project_del({
            id: row.id
          }).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();

              if (vm.showTable === 0) {
                vm.init1();
              } else {
                vm.init();
              }
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    refresh: function refresh() {
      if (this.showTable === 0) {
        this.getcompany();
      } else {
        this.init();
      }
    },
    changeTableHeight: function changeTableHeight() {
      this.tableHeight = window.innerHeight - this.$refs.gridCom.offsetTop - 10;

      if (this.$refs.search) {
        var h = this.$refs.search.offsetHeight;
        this.tableHeight = this.tableHeight - h;
      } else {
        this.tableHeight = this.tableHeight - 45;
      }

      console.log(this.tableHeight);
      return this.tableHeight;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.refresh();

    window.onresize = function () {
      _this6.changeTableHeight();
    };

    this.$nextTick(function () {
      _this6.changeTableHeight();
    });
  },
  created: function created() {// this.getPageSizeToStorage();
  },
  destroyed: function destroyed() {
    window.onresize = null;
  }
};